module.exports = __webpack_public_path__ + "img/guardian.0f33e2c7.svg";